import * as tslib_1 from "tslib";
import { getOffsetLeft, getOffsetTop } from './popoverUtils';
/**
 * @private
 *
 * 获取偏移位置
 *
 * @param {*} elemRect
 * @param {*} contentAnchorOffset
 */
export function getTransformOrigin(elemRect, contentAnchorOffset, transformOrigin) {
    if (contentAnchorOffset === void 0) { contentAnchorOffset = 0; }
    return {
        vertical: contentAnchorOffset > 0
            ? contentAnchorOffset
            : getOffsetTop(elemRect, transformOrigin.vertical),
        horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal),
    };
}
/**
 * @private
 * 获取popover目标元素的位置
 *
 * @param {*} anchorRect
 * @param {*} anchorOrigin
 */
export function getTargetPosition(anchorRect, anchorOrigin) {
    return {
        top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
        left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal),
    };
}
/**
 * @private
 *
 * 适应边界： 调整指定元素的位置，以让元素完全显示在容器的边界内部。
 *
 * @param {*} elementRect
 * @param {*} containerRect
 * @param {*} marginThreshold
 */
export function suitBorder(elementRect, elementOffset, containerRect, marginThreshold) {
    var left = elementRect.left, top = elementRect.top;
    var bottom = elementRect.bottom, right = elementRect.right;
    var heightThreshold = containerRect.height - marginThreshold;
    var widthThreshold = containerRect.width - marginThreshold;
    var transformOrigin = tslib_1.__assign({}, elementOffset);
    // Check if the vertical axis needs shifting
    if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
    }
    else if (bottom > heightThreshold) {
        var diff = bottom - heightThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
    }
    // Check if the horizontal axis needs shifting
    if (left < marginThreshold) {
        var diff = left - marginThreshold;
        left -= diff;
        transformOrigin.horizontal += diff;
    }
    else if (right > widthThreshold) {
        var diff = right - widthThreshold;
        left -= diff;
        transformOrigin.horizontal += diff;
    }
    return {
        top: top,
        left: left,
        transformOrigin: transformOrigin,
    };
}
var Rect = /** @class */ (function () {
    function Rect(width, height, left, top) {
        this.width = width;
        this.height = height;
        this.left = left;
        this.right = left + width;
        this.top = top;
        this.bottom = top + height;
    }
    return Rect;
}());
export { Rect };
//# sourceMappingURL=PopoverPositionUtils.js.map